// Puente global para disparar snackbars desde fuera de React (axios
// interceptor, thunks sin componente, monitors de background…). El
// `NotistackProvider` registra su ref al montar. Fallback silencioso
// si aún no está registrado (ej. arranque antes del primer render).

let providerRef = null;

export function registerSnackbarProvider(ref) {
  providerRef = ref;
}

/**
 * Encola un snackbar programático. Firma alineada con notistack:
 *   showSnackbar("mensaje", { variant: "error", key, autoHideDuration })
 */
export function showSnackbar(message, options = {}) {
  try {
    if (!providerRef?.enqueueSnackbar) return null;
    return providerRef.enqueueSnackbar(message, options);
  } catch { return null; }
}

export function closeSnackbar(key) {
  try {
    if (!providerRef?.closeSnackbar) return;
    providerRef.closeSnackbar(key);
  } catch { /* noop */ }
}
